import type { HttpTransport } from '@mangovoice/api-client'
import type {
  Contact,
  ContactSource,
  PaginatedApiResult,
} from '@mangovoice/types'

import { stringifyParams } from './utils'

export interface ContactSourcesQueryParams {
  limit?: number
  offset?: number
}

export interface ContactsQueryParams {
  pbx_id?: number
  limit?: number
  offset?: number
  search?: string
  contact_source_id?: number
  ordering?: string
  [key: string]: unknown
}

export function createContactsResource(transport: HttpTransport) {
  return {
    getContactSources: (params?: ContactSourcesQueryParams) => {
      const qs = stringifyParams((params ?? {}) as Record<string, unknown>)
      return transport.get<PaginatedApiResult<ContactSource>>(
        qs ? `/contact-sources/?${qs}` : '/contact-sources/',
      )
    },

    getContactSource: (contactSourceId: number) =>
      transport.get<ContactSource>(`/contact-sources/${contactSourceId}/`),

    getContacts: (
      params: ContactsQueryParams,
      config?: { signal?: AbortSignal },
    ) => {
      const qs = stringifyParams(params as Record<string, unknown>)
      return transport.get<PaginatedApiResult<Contact>>(
        `/contacts/?${qs}`,
        undefined,
        config,
      )
    },

    getContact: (contactId: number | string, pbxId: number) =>
      transport.get<Contact>(`/contacts/${contactId}/?pbx_id=${pbxId}`),
  }
}
